import React from 'react';
import { Icon } from './Icon.js';
export const IconSavedItems = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M8 3V13L12 10.4194L16 13V3", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("rect", { x: "21", y: "3", width: "18", height: "18", transform: "rotate(90 21 3)", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconSavedItems.js.map